// Copyright (c) 2025 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import api from './advisorApi';
import type { BrandingConfig } from '../types/branding';

export const brandingApi = {
  /**
   * Get branding configuration for a brokerage
   * @param brokerageId - Brokerage UUID
   * @returns Resolved branding configuration with logo, tier, badge flag, and custom styles
   */
  getBrandingConfig: async (brokerageId: string): Promise<BrandingConfig> => {
    const response = await api.get<BrandingConfig>(`/branding/config/${brokerageId}`);
    return response.data;
  },

  /**
   * Get logo URL for a brokerage
   * @param brokerageId - Brokerage UUID
   * @returns Logo URL based on branding tier
   */
  getLogoUrl: async (brokerageId: string): Promise<string> => {
    const response = await api.get<{ logoUrl: string }>(`/branding/logo/${brokerageId}`);
    return response.data.logoUrl;
  }
};
